<mat-card class="matContainer">
  <form [formGroup]="workflowDetailsFrom">
    <mat-form-field *ngFor="let formField of formFields" [ngClass]="{'disabled-cursor': workflowDetailsFrom.disabled}">
      <mat-label [ngClass]="{'disabled-cursor': workflowDetailsFrom.disabled}">{{ formField.label }}</mat-label>
      <input matInput [formControlName]="formField.controlName"
        [ngClass]="{'disabled-cursor': workflowDetailsFrom.disabled}">
    </mat-form-field>
  </form>
</mat-card>